import { consoleWarn } from 'vuetify/lib/util/console';
import Vue from 'vue';
import Class from '../data/Class';
import Schedule from '../data/Schedule';
import ScheduleListRow from '../data/ScheduleListRow';
import ScheduleTick from '../data/ScheduleTick';
import Member from '../data/Member';
import Project from '../data/Project';
import Color from '../data/Color';
import Addtional from '../data/Addtional';
import Util from '../classes/Util';
import {
	CALENDAR_TICK, UNIT_WIDTH, DISPLAY_PERIOD, PERMISSION, FILTERING_STATUS, DISPLAY_LIST_TYPE,
} from '../data/Const';
import clonedeep from 'lodash/cloneDeep';
const strftime = require('strftime');

const createClasses = (relation_code, relation_type, classes) => {
	return classes.map(cls => {
		let c = state.master.data_class.filter(c => c.code == cls.code)[0];
		return new Class(Object.assign(Object.assign({}, c), {
			relation_code: relation_code,
			relation_type: relation_type,
		}));
	});
};
const createSchedule = (schedules) => {
	return schedules.map(s => {
		return new Schedule({
			code: s.code,
			project_code: s.project_code,
			member_code: s.member_code,
			begin: new ScheduleTick(s.begin),
			end: new ScheduleTick(s.end),
			title: s.title,
			progress_rate: s.progress_rate,
			color_code: s.color_code,
		});
	});
};
let stock_members = [];
const createMembers = (members) => {
	return members.map(item => {
		_createScheduleListRowState(state.list_row_state[DISPLAY_LIST_TYPE.MEMBER], {
			code: item.code,
			is_expanded: !!item.is_expanded,
		});
		
		let m = state.master.data_member.filter(m => m.code == item.code)[0];
		let projects = [];
		let stock = stock_members.filter(stock => stock.code == m.code)[0];
		if (stock !== undefined) {
			projects = stock.projects;
		} else {
			stock_members.push({code: m.code, projects: projects});
		}
		let status;
		switch (item.status) {
			case 0:
			status = Member.STATUS.UNKNOWN;
			break;
			case 1:
			status = Member.STATUS.PROGRESS;
			break;
			case 2:
			status = Member.STATUS.DONE;
			break;
		}
		
		return new Member(Object.assign(Object.assign({}, m), {
			seq: item.seq,
			status: status,
			alert: (item.alert != 0),
			classes: createClasses(m.code, Class.RELATION_TYPE.MEMBER, m.classes),
			schedules: createSchedule(item.schedules),
			projects: projects,
			color_code: item.color_code,
			is_expanded: true,
		}));
	});
};

const createAddtional = (additional) => {
	return additional.map(add => {
		return new Addtional({
			code: add.code,
			name: add.name,
			type: add.type,
			min_length: add.min_length,
			max_length: add.max_length,
			seq: add.seq,
		});
	});
};

const createProjectPinned = (project_pinned) => {
	let pinned = {};
	for (let project_id in project_pinned) {
		pinned[project_id] = {};
		for (let type in project_pinned[project_id]) {
			pinned[project_id][type] = {};
			for (let pinned_id in project_pinned[project_id][type]) {
				pinned[project_id][type][pinned_id] = project_pinned[project_id][type][pinned_id] === 1 ? true : false;
			}
		}
	}
	
	return pinned;
};

const MODE = {
	VIEW: 0,
	EDIT: 1,
};

const state = {
	mode: MODE.VIEW,
	display_list_type: DISPLAY_LIST_TYPE.PROJECT,
	is_all_expanded: true,
	is_scrolling_to_today: false,
	is_show_freeperson: true,
	size: {
		width: 0,
		height: 0,
	},
	position: {
		board_left: 0,
		hscroll: 0,
	},
	master: {
		data_member: [],
		data_class: [],
		data_color: [],
		data_additional: [],
		data_project_pinned: {},
	},
	list_row_state: [
		{},	// PROJECT
		{},	// MEMBER
	],
	list_data_state: {
		project: [],
		member: [],
	},
	list_project: [],
	list_member: [],
	delete_project: [],
	calendar: {
		tick: CALENDAR_TICK.DAY,
		list: [],
		yearmonth: null,
	},
	loading: true,
	notifications: [],
	dataset_id: null,
	exclusive : false,
	print_schedule : false,
	access_token: null,
	refresh_token: null,
	socketio: {
		socketio: null,
		socketio_id: null,
		listener: {},
	},
	dataset_manager: null,
	schedule_filter: {
		begin: null,
		end: null,
		projects: [],
		members: [],
		classes: [],
		color_project: [],
		color_member: [],
		alert:false,
		status: FILTERING_STATUS.PROGRESS,
		additional_info_data: [],
	},
	reset_passwd: false,
	member_filter: {
		begin: null,
		begin_term: null,
		end: null,
		end_term: null,
		classes: [],
	},
	save_display_left_day: null,
};

const color_filter = (array) => {
	return array.filter(fc => {
		return state.master.data_color.some(c => c.code === fc.code);
	});
};

const list_project_filter = (list, cond) => {
	if(cond.begin == null && 
		cond.end == null && 
		cond.parent.length == 0 && 
		cond.children.length == 0 && 
		cond.classes.length == 0 && 
		cond.color_project.length == 0 && 
		cond.color_member.length == 0 &&
		!cond.alert && 
		cond.additional_info_data.length == 0 &&
		cond.status == FILTERING_STATUS.ALL)
		return list;
	
	return list.filter((item) => {
		let match_childrens = item.children.filter((c) => {
			let cs = list_project_schedule_filter(c.schedules, cond);
			if((cond.begin != null || cond.end != null) && cs.length == 0)
				return false;
			return true;
		});
		
		let list_data_state = state.list_data_state.project;
		if (list_data_state.length > 0) {
			for (let data_state of list_data_state) {
				if(data_state == item.code)
					return true;
			}
		}
		
		let schedules = list_project_schedule_filter(item.schedules, cond);
		if((cond.begin != null || cond.end != null) && schedules.length == 0 && match_childrens.length == 0)
			return false;
			
		let match = null;
		if (cond.parent.length > 0){
			match = false;
			for(let p of cond.parent) {
				if(p.code === item.code)
					match = true;
			}
		}
		
		let additional_total_match = null;
		if (cond.additional_info_data.length > 0) {
			cond.additional_info_data.forEach(data => {
				if (data.name || data.min || data.max) {
					const data_additional = state.master.data_additional.filter(additional => {
						return additional.code == data.code;
					});
					const project_additional = item.project_additional.filter(additional => {
						return additional.additional_id == data.code;
					});
					if (data_additional.length > 0 && project_additional.length > 0) {
						let additional_match = false;
						if (data_additional[0].isNumber) {
							if (project_additional[0].value) {
								if (data.min && data.max) {
									additional_match = Number(project_additional[0].value) >= Number(data.min) && Number(project_additional[0].value) <= Number(data.max); 
								} else if (data.min) {
									additional_match = Number(project_additional[0].value) >= Number(data.min);
								} else {
									additional_match = Number(project_additional[0].value) <= Number(data.max);
								}
							} else {
								additional_match = false;
							}
						} else {
							additional_match = project_additional[0].value.search(Util.replaceEscapeString(data.name)) >= 0;
						}
						if (additional_total_match === null)
							additional_total_match = additional_match;
						else
							additional_total_match = additional_total_match && additional_match;
					}
				}
			});
		}
		if (match === null) {
			match = additional_total_match;
		} else {
			if (additional_total_match !== null) {
				match = match && additional_total_match;
			}
		} 
		
		if (cond.children.length > 0) {
			let match_children = false;
			match_childrens = match_childrens.filter(c => {
				for (let child of cond.children) {
					if (child.code == c.code) {
						return true;
					}
				}
				return false;
			})
			if (match_childrens.length > 0) {
				match_children = true;
			}

			if (match === null) {
				match = match_children;
			} else if (match) {
				match = true;
			} else {
				match = match && match_children;
			} 
		}
		
		if (cond.classes.length > 0) {
			let match_classes = false;
			for(let c of item.classes) {
				for(let cls of cond.classes) {
					if(cls.code == c.code)
						match_classes = true;
				}
			}

			if (match === null)
				match = match_classes;
			else
				match = match && match_classes;
		}
		
		if (cond.color_project.length > 0) {
			let match_color_project = false;
			
			if (schedules.length > 0)
				match_color_project = true;
			
			if (match === null)
				match = match_color_project;
			else
				match = match && match_color_project;
		}
		
		if (cond.color_member.length > 0) {
			let match_color_member = false;
			
			let childrens = item.children.filter((c) => {
				let cs = list_project_schedule_filter(c.schedules, cond);
				if(cs.length == 0)
					return false;
				return true;
			});
			
			if (childrens.length > 0)
				match_color_member = true;
			
			if (match === null)
				match = match_color_member;
			else
				match = match && match_color_member;
		}
		
		if (cond.status != FILTERING_STATUS.ALL) {
			let match_status = false;
			if(cond.status == FILTERING_STATUS.DONE)
				match_status = item.status == Project.STATUS.DONE;
			else if(cond.status == FILTERING_STATUS.PROGRESS)
				match_status = item.status == Project.STATUS.PROGRESS;
			
			if(match === null)
				match = match_status;
			else
				match = match && match_status;
		}
		
		if (cond.alert) {
			let match_alert = false;
			if (item.alert) {
				match_alert = true;
			} else {
				let children_alert = match_childrens.filter( c => {
					return c.alert;
				});
				if (children_alert.length > 0)
					match_alert = true;
			}
			
			if(match === null)
				match = match_alert;
			else
				match = match && match_alert;
		}
		
		if(match === null)
			match = true;
		return match;
	});
};

const list_member_filter = (list, cond) => {
	if(cond.begin == null && 
		cond.end == null && 
		cond.parent.length == 0 && 
		cond.children.length == 0 && 
		cond.classes.length == 0 && 
		cond.color_project.length == 0 && 
		cond.color_member.length == 0 &&
		!cond.alert && 
		cond.additional_info_data.length == 0 &&
		cond.status == FILTERING_STATUS.ALL)
		return list;
	
	return list.filter((item) => {
		let children = list_member_children_filter(item.children, cond);
		let children_schedhles = item.children.filter((c) => {
			let cs = list_project_schedule_filter(c.schedules, cond);
			if((cond.begin != null || cond.end != null) && cs.length == 0)
				return false;
			return true;
		});
		let match = null;
		if (cond.parent.length > 0){
			match = false;
			for(let p of cond.parent) {
				if(p.code === item.code)
					match = true;
			}
		}
		
		let schedules = list_member_schedule_filter(item.schedules, cond);
		if((cond.begin != null || cond.end != null) && schedules.length == 0 && children_schedhles.length == 0)
			return false;
		
		if (cond.classes.length > 0) {
			let match_classes = false;
			for(let c of item.classes) {
				for(let cls of cond.classes) {
					if(cls.code == c.code)
						match_classes = true;
				}
			}
			if (match === null)
				match = match_classes;
			else
				match = match && match_classes;
		}
		
		if (cond.color_member.length > 0) {
			let match_color_member = false;
			
			if (schedules.length > 0)
				match_color_member = true;
			
			if (match === null)
				match = match_color_member;
			else
				match = match && match_color_member;
		}
		
		if (cond.alert) {
			let match_alert = false;
			if (item.alert)
				match_alert = true;
			
			if(match === null)
				match = match_alert;
			else
				match = match && match_alert;
		}
		if (cond.status != FILTERING_STATUS.ALL) {
			let children_status = children.filter( c => {
				if(cond.status == FILTERING_STATUS.DONE && c.status != Member.STATUS.DONE)
					return false;
				else if(cond.status == FILTERING_STATUS.PROGRESS && c.status != Member.STATUS.PROGRESS)
					return false;
				
				return true;
			});
			if(match === null)
				match = children_status.length > 0;
		}
		if(match === null && children.length == 0)
			match = false;
		else if(match === null && children.length > 0)
			match = true
		;
		return match;
	});
};

const list_project_children_filter = (list, cond) => {
	if(cond.begin == null && 
		cond.end == null && 
		cond.parent.length == 0 && 
		cond.children.length == 0 && 
		cond.classes.length == 0 && 
		cond.color_project.length == 0 && 
		cond.color_member.length == 0 &&
		!cond.alert && 
		cond.additional_info_data.length == 0 &&
		cond.status == FILTERING_STATUS.ALL)
		return list;
	
	return list.filter(item => {
		let list_data_state = state.list_data_state.member;
		if(list_data_state.length > 0) {
			for (let data_state of list_data_state) {
				if(data_state.member_code == item.code)
					return true;
			}
		}
		
		let schedules = list_project_schedule_filter(item.schedules, cond);
		if((cond.begin != null || cond.end != null) && schedules.length == 0)
			return false;
		
		if (cond.children.length > 0) {
			let match = false;
			for(let m of cond.children) {
				if(m.code === item.code)
					match = true;
			}
			if (!match)
				return false;
		}
			
		if (cond.color_member.length > 0) {
			let match_color_member = false;
			
			let member_schedules = list_project_schedule_filter(item.schedules, cond);
			if (member_schedules.length > 0)
				match_color_member = true;
			
			if (!match_color_member)
				return false;
		}
		
		return true;
	});
};
const list_member_children_filter = (list, cond) => {
	if(cond.begin == null && 
		cond.end == null && 
		cond.parent.length == 0 && 
		cond.children.length == 0 && 
		cond.classes.length == 0 && 
		cond.color_project.length == 0 && 
		cond.color_member.length == 0 &&
		!cond.alert && 
		cond.additional_info_data.length == 0 &&
		cond.status == FILTERING_STATUS.ALL)
		return list;
	
	return list.filter(item => {
		if (cond.children.length > 0) {
			let match = false;
			for(let m of cond.children) {
				if(m.code === item.code)
					match = true;
			}
			if (!match)
				return false;
		}
		
		if (cond.additional_info_data.length > 0) {
			let additional_total_match = true;
			cond.additional_info_data.forEach(data => {
				if (data.name || data.min || data.max) {
					const data_additional = state.master.data_additional.filter(additional => {
						return additional.code == data.code;
					});
					const project_additional = item.project_additional.filter(additional => {
						return additional.additional_id == data.code;
					});
					if (data_additional.length > 0 && project_additional.length > 0) {
						let additional_match = false;
						if (data_additional[0].isNumber) {
							if (project_additional[0].value) {
								if (data.min && data.max) {
									additional_match = Number(project_additional[0].value) >= Number(data.min) && Number(project_additional[0].value) <= Number(data.max); 
								} else if (data.min) {
									additional_match = Number(project_additional[0].value) >= Number(data.min);
								} else {
									additional_match = Number(project_additional[0].value) <= Number(data.max);
								}
							} else {
								additional_match = false;
							}
						} else {
							additional_match = project_additional[0].value.search(Util.replaceEscapeString(data.name)) >= 0;
						}
						if (additional_total_match === null)
							additional_total_match = additional_match;
						else
							additional_total_match = additional_total_match && additional_match;
					}
				}
			});
			if (!additional_total_match)
				return false;
		}
		
		if (cond.color_member.length > 0) {
			let match_color_member = false;
			
			let member_schedules = list_member_schedule_filter(item.schedules, cond);
			if (member_schedules.length > 0)
				match_color_member = true;
			
			if (!match_color_member)
				return false;
		}
		
		let schedules = list_member_schedule_filter(item.schedules, cond);
		if((cond.begin != null || cond.end != null) && schedules.length == 0)
			return false;
		
		return true;
	});
};

const list_project_schedule_filter = (list, cond) => {
	if(cond.begin == null && 
		cond.end == null && 
		cond.parent.length == 0 && 
		cond.children.length == 0 && 
		cond.classes.length == 0 && 
		cond.color_project.length == 0 && 
		cond.color_member.length == 0 &&
		!cond.alert && 
		cond.additional_info_data.length == 0 &&
		cond.status == FILTERING_STATUS.ALL)
		return list;
	
	return list.filter(item => {
		let match = false;
		
		if(cond.begin || cond.end) {
			if(cond.begin && cond.end) {
				let filter_begin =  new Date(cond.begin.replace(/-/g, '/'));
				let filter_end = new Date(cond.end.replace(/-/g, '/') + ' 12:00:00');
				match = item.begin.date >= filter_begin && item.end.date <= filter_end;
			} else if(cond.begin && cond.end == null) {
				let filter_begin =  new Date(cond.begin.replace(/-/g, '/'));
				match = item.begin.date >= filter_begin;
			} else if(cond.begin == null && cond.end) {
				let filter_end = new Date(cond.end.replace(/-/g, '/') + ' 12:00:00');
				match = item.end.date <= filter_end;
			}
			if(!match)
				return false;
		}
		
		if (cond.color_project.length > 0) {
			let match_color_project = false;
			for(let clr of color_filter(cond.color_project)) {
				if (is_default_color(item.color_code)) {
					let project = state.list_project.find(p => p.code === item.project_code);
					if (project !== undefined && project.color_code === clr.code)
						match_color_project = true;
				} else {
					if (item.color_code === clr.code)
						match_color_project = true;
				}
			}
			if (!match_color_project && !item.member_code)
				return false;
		}
		
		if (cond.color_member.length > 0) {
			let match_color_member = false;
			for(let clr of color_filter(cond.color_member)) {
				if (is_default_color(item.color_code)) {
					let member = getters.memberData(state)(item.member_code);
					if (member !== null && member.color_code === clr.code)
						match_color_member = true;
				} else {
					if (item.color_code === clr.code)
						match_color_member = true;
				}
			}
			if (!match_color_member && item.member_code)
				return false;
		}
		
		return true;
	});
};

const list_member_schedule_filter = (list, cond) => {
	if(cond.begin == null && 
		cond.end == null && 
		cond.parent.length == 0 && 
		cond.children.length == 0 && 
		cond.classes.length == 0 && 
		cond.color_project.length == 0 && 
		cond.color_member.length == 0 &&
		!cond.alert && 
		cond.additional_info_data.length == 0 &&
		cond.status == FILTERING_STATUS.ALL)
		return list;
	
	return list.filter(item => {
		let match = false;
		
		if(cond.begin || cond.end) {
			if(cond.begin && cond.end) {
				let filter_begin =  new Date(cond.begin.replace(/-/g, '/'));
				let filter_end = new Date(cond.end.replace(/-/g, '/') + ' 12:00:00');
				match = item.begin.date >= filter_begin && item.end.date <= filter_end;
			} else if(cond.begin && cond.end == null) {
				let filter_begin =  new Date(cond.begin.replace(/-/g, '/'));
				match = item.begin.date >= filter_begin;
			} else if(cond.begin == null && cond.end) {
				let filter_end = new Date(cond.end.replace(/-/g, '/') + ' 12:00:00');
				match = item.end.date <= filter_end;
			}
			if(!match)
				return false;
		}
		if (cond.children.length > 0) {
			match = false;
			for(let project of cond.children) {
				if(item.project_code == project.code)
					match = true
			}
			if(!match)
				return false;
		}
		
		if (cond.additional_info_data.length > 0) {
			let additional_total_match = true;
			const project_data = state.list_project.filter(p => {
				return p.code == item.project_code;
			});
			if (project_data.length == 0)
				return false;
			
			cond.additional_info_data.forEach(data => {
				if (data.name || data.min || data.max) {
					const data_additional = state.master.data_additional.filter(additional => {
						return additional.code == data.code;
					});
					const project_additional = project_data[0].project_additional.filter(additional => {
						return additional.additional_id == data.code;
					});
					if (data_additional.length > 0 && project_additional.length > 0) {
						let additional_match = false;
						if (data_additional[0].isNumber) {
							if (project_additional[0].value) {
								if (data.min && data.max) {
									additional_match = Number(project_additional[0].value) >= Number(data.min) && Number(project_additional[0].value) <= Number(data.max); 
								} else if (data.min) {
									additional_match = Number(project_additional[0].value) >= Number(data.min);
								} else {
									additional_match = Number(project_additional[0].value) <= Number(data.max);
								}
							} else {
								additional_match = false;
							}
						} else {
							additional_match = project_additional[0].value.search(Util.replaceEscapeString(data.name)) >= 0;
						}
						if (additional_total_match === null)
							additional_total_match = additional_match;
						else
							additional_total_match = additional_total_match && additional_match;
					}
				}
			});
			if (!additional_total_match)
				return false;
		}
		
		if (cond.color_member.length > 0) {
			let match_color_member = false;
			for(let clr of color_filter(cond.color_member)) {
				if (is_default_color(item.color_code)) {
					let member = getters.memberData(state)(item.member_code);
					if (member !== null && member.color_code === clr.code)
						match_color_member = true;
				} else {
					if (item.color_code === clr.code)
						match_color_member = true;
				}
			}
			if (!match_color_member)
				return false;
		}
		return true;
	});
};

const is_default_color = (code) => {
	let color = state.master.data_color.find(c => c.code === code);
	if (color === undefined)
		return false;
	return color.default_value;
};


import Day from '../data/Day';
import Term from '../data/Term';
import Week from '../data/Week';

const _unitWidth = (tick) => {
	if (tick === CALENDAR_TICK.TERM)
		return UNIT_WIDTH.TERM;
	if (tick === CALENDAR_TICK.WEEK)
		return UNIT_WIDTH.WEEK;
	return UNIT_WIDTH.DAY;
};
const _unitTicks = (tick) => {
	if (tick === CALENDAR_TICK.TERM)
		return 1;
	if (tick === CALENDAR_TICK.DAY)
		return 2;
	if (tick === CALENDAR_TICK.WEEK)
		return 14;
	return 0;
};

const _hasPermission = (state, pms) => {
	if (!state.access_token)
		return false;

	return (state.access_token.pms & pms) > 0;
};

const member_worker_filter = (member) => {
	return member.filter(m => m.permission & PERMISSION.TYPE.WORKER);
};

const getters = {
	isListWidthNarrow: function(state, getters) {
		return !getters.isViewer;
	},
	listWidth: function(state, getters) {
		let width = 300 + state.position.board_left;
		if (getters.isListWidthNarrow)
			width -= 56;
		return width;
	},
	display_list: function (state, getters) {
		return getters.any_display_list(state.display_list_type);
	},
	any_display_list: (state) => (list_type) => {
		if (list_type === DISPLAY_LIST_TYPE.PROJECT)
			return list_project_filter(state.list_project, {
				begin: state.schedule_filter.begin,
				end: state.schedule_filter.end,
				parent: state.schedule_filter.projects,
				children: state.schedule_filter.members,
				classes: state.schedule_filter.classes,
				color_project: state.schedule_filter.color_project,
				color_member: state.schedule_filter.color_member,
				alert: state.schedule_filter.alert,
				status: state.schedule_filter.status,
				additional_info_data: state.schedule_filter.additional_info_data,
			});
		else
			return list_member_filter(state.list_member, {
				begin: state.schedule_filter.begin,
				end: state.schedule_filter.end,
				parent: state.schedule_filter.members,
				children: state.schedule_filter.projects,
				classes: state.schedule_filter.classes,
				color_project: state.schedule_filter.color_project,
				color_member: state.schedule_filter.color_member,
				alert: state.schedule_filter.alert,
				status: state.schedule_filter.status,
				additional_info_data: state.schedule_filter.additional_info_data,
			});
	},
	holiday: function(state) {
		return state.calendar.list.filter(h => { return h.holiday != null });
	},
	calendar_yearmonth: function (state) {
		return state.calendar.yearmonth;
	},
	height: function(state) {
		return state.size.height;
	},
	width: function(state) {
		return state.size.width;
	},
	innerWidth: function(state, getters) {
		let width = 0;
		if (state.calendar.tick === CALENDAR_TICK.TERM) {
			width = UNIT_WIDTH.TERM * state.calendar.list.length;
		} else if (state.calendar.tick === CALENDAR_TICK.DAY) {
			width =  UNIT_WIDTH.DAY * state.calendar.list.length;
		} else if (state.calendar.tick === CALENDAR_TICK.WEEK) {
			let weeks = 0;
			getters.calendar_yearmonth.forEach(ym => {
				weeks += ym.weeks.length;
			});
			width = UNIT_WIDTH.DAY * weeks;
		}

		return width;
	},
	boardLeftPosition: function(state) {
		return state.position.board_left;
	},
	hscroll: function(state) {
		return state.position.hscroll;
	},
	isEditable: function(state) {
		return state.mode == MODE.EDIT;
	},
	isDisplayListTypeMember: function(state) {
		return state.display_list_type == DISPLAY_LIST_TYPE.MEMBER;
	},
	isDisplayListTypeProject: function(state) {
		return state.display_list_type == DISPLAY_LIST_TYPE.PROJECT;
	},
	displayListType: function(state) {
		return state.display_list_type;
	},
	calendarTick : function(state) {
		return state.calendar.tick;
	},
	isAllExpanded: function(state) {
		return state.is_all_expanded;
	},
	isExpandedScheduleListRow: (state) => (row) => {
		let list_row_state = row.isProject ? state.list_row_state[DISPLAY_LIST_TYPE.PROJECT]
		                                   : state.list_row_state[DISPLAY_LIST_TYPE.MEMBER];
		return list_row_state[row.code].is_expanded;
	},
	isScrollingToToday: function(state) {
		return state.is_scrolling_to_today;
	},
	isShowFreePerson: function(state) {
		return state.is_show_freeperson;
	},
	scrollTodayOffset: function() {
		return (UNIT_WIDTH.TICK * 4);
	},
	displayDays: function(state, getters) {
		return (tick) => {
			if (tick === undefined)
				tick = state.calendar.tick;
			return Math.floor((state.size.width - getters.listWidth) / _unitWidth(tick));
		};
	},
	displayLeftDay: function(state, getters) {
		let base = getters.baseDate;
		let days = state.position.hscroll / getters.unitWidth;

		let left = new Date(base.getTime());
		left.setDate(left.getDate() + days);
		return left;
	},
	positionToday: function(state, getters) {
		let target = new Date();
		return getters.positionAnyday(target);
	},
	positionAnyday: (state, getters) => (date) => {
		let target = date;
		let basedate = getters.baseDate;

		if (state.calendar.tick === CALENDAR_TICK.WEEK) {
			let week_target = Week.fromDate(target);
			let week_base = Week.fromDate(basedate);
			let diff_weeks = 0;
			let curr = week_base.begin.date;
			if (curr.getMonth() != basedate.getMonth())
				curr.setDate(curr.getDate() + 7);	// 開始が月跨ぎは表示されないのでスキップ
			let end = week_target.begin.date;
			if (curr < end) {
				while (curr < end) {
					diff_weeks += 1;
					curr.setDate(curr.getDate() + 7);
				}
			} else {
				while (curr > end) {
					diff_weeks -= 1;
					curr.setDate(curr.getDate() - 7);
				}
			}
			return UNIT_WIDTH.TICK * diff_weeks;
		} else {
			return getters.unitWidth * Math.floor((target.getTime() - basedate.getTime()) / 86400000);
		}
	},
	unitWidth: function(state) {
		return _unitWidth(state.calendar.tick);
	},
	unitTicks: function(state) {
		return _unitTicks(state.calendar.tick);
	},
	baseDate: function(state) {
		if (state.calendar.list.length == 0)
			return new Date();
		let baseCalendar = state.calendar.list[0].code;
		let baseYear = Number(baseCalendar.substr(0, 4));
		let baseMonth = Number(baseCalendar.substr(4, 2)) - 1;
		let baseDay= Number(baseCalendar.substr(6, 2));
		return new Date(baseYear, baseMonth, baseDay);
	},
	endDate: function(state) {
		if (state.calendar.list.length == 0)
			return new Date();
		let endCalendar = state.calendar.list[state.calendar.list.length - 1].code;
		let endYear = Number(endCalendar.substr(0, 4));
		let endMonth = Number(endCalendar.substr(4, 2)) - 1;
		let endDay= Number(endCalendar.substr(6, 2));
		return new Date(endYear, endMonth, endDay);
	},
	expandDate: function(state, getters) {
		let expandDate = 0;
		switch(getters.calendarTick) {
		case CALENDAR_TICK.TERM:{
			expandDate = DISPLAY_PERIOD.EXPAND.TERM;
			break;
		}
		case CALENDAR_TICK.DAY:{
			expandDate = DISPLAY_PERIOD.EXPAND.DAY;
			break;
		}
		case CALENDAR_TICK.WEEK:{
			expandDate = DISPLAY_PERIOD.EXPAND.WEEK;
			break;
		}}
		return expandDate;
	},
	calendarBaseDate: function(state, getters) {
		if (getters.calendarTick === CALENDAR_TICK.WEEK) {
			let first_day_of_week = getters.calendar_yearmonth[0].weeks[0];
			return first_day_of_week.begin.date;
		} 
		return getters.baseDate;
	},
	freePersonsBySchedule: function(state) {
		return (schedule) => {
			let free = member_worker_filter(state.master.data_member).map(m => {
				return { 
					code: m.code, 
					name: m.name, 
					tel: m.tel, 
					classes: createClasses(m.code, Class.RELATION_TYPE.MEMBER, m.classes), 
				};
			});

			state.list_member.forEach(m => {
				let pre_schedule = null;
				let match = m.schedules.filter(s => {
					let overlap = s.createOverlap(schedule);
					if (overlap === null)
						return false;
					if(pre_schedule)
						if(String(overlap.begin.code).substr(0, 8) === String(pre_schedule.begin.code).substr(0, 8) 
							&& overlap.begin.term !== pre_schedule.begin.term){
								pre_schedule = overlap;
								return true;
							}
					pre_schedule = overlap;
					return schedule.duration === overlap.duration;
				});
				if (match.length > 0) {
					array_remove(free, m, (a, b) => {
						return a.code == b.code;
					});
				}
			});

			return free;
		};
	},
	memberList: function(state) {
		return state.master.data_member;
	},
	mstMemberData: function(state) {
		return (code) => {
			let m = state.master.data_member.filter(m => { return m.code === code });
			if(m.length > 0)
				return m[0];
			return null;
		};
	},
	memberData: function(state) {
		return (code) => {
			let m = state.list_member.filter(m => { return m.code === code });
			if(m.length > 0)
				return m[0];
			return null;
		};
	},
	isLoading: function(state) {
		return state.loading;
	},
	notifications: function(state) {
		return state.notifications;
	},
	isExclusive: function(state) {
		return state.exclusive;
	},
	isPrintSchedule: function(state){
		return state.print_schedule;
	},
	isConnectedSocketIO: function(state) {
		return state.socketio.socketio !== null;
	},
	socketioID: function(state){
		return state.socketio.socketio_id;
	},
	accessToken: function(state) {
		return state.access_token;
	},
	refreshToken: function(state) {
		return state.refresh_token;
	},
	dataSet: function(state) {
		let hash = state.list_project.map(p => {
			let row_state = state.list_row_state[DISPLAY_LIST_TYPE.PROJECT][p.code];
			let status;
			switch (p.status) {
			case Project.STATUS.UNKNOWN:
				status = 0;
				break;
			case Project.STATUS.PROGRESS:
				status = 1;
				break;
			case Project.STATUS.DONE:
				status = 2;
				break;
			}
			return {
				code: p.code,
				name: p.name,
				seq: p.seq,
				is_expanded: row_state.is_expanded ? 1 : 0,
				is_updated: p.is_updated ? 1 : 0,
				status: status,
				alert: p.alert ? 1 : 0,
				remarks: p.remarks,
				classes: p.classes.map(c => c.asHash()),
				schedules: p.schedules.map(s => {
					return s.asHash();
				}),
				children: p.children.map(c => {
					let row_state = state.list_row_state[DISPLAY_LIST_TYPE.MEMBER][c.code];
					let cld_status;
					switch (c.status) {
					case Member.STATUS.UNKNOWN:
						cld_status = 0;
						break;
					case Member.STATUS.PROGRESS:
						cld_status = 1;
						break;
					case Member.STATUS.DONE:
						cld_status = 2;
						break;
					}
					return {
						code: c.code,
						is_expanded: row_state.is_expanded,
						item_type: c.item_type,
						name: c.name,
						seq: c.seq,
						schedules:c.schedules.map(s => {
							return s.asHash();
						}),
						status:cld_status,
						alert: c.alert ? 1 : 0,
						classes: c.classes.map(c => c.asHash()),
						tel:c.tel,
						color_code: c.color_code,
					};
				}),
				color_code: p.color_code,
				project_additional: p.project_additional.map(pa => {
					return pa.asHash();
				}),
			};
		})
		let hash_member = state.master.data_member.map(m => {
			return {
				code: m.code,
				seq: m.seq,
				login_id: m.login_id,
				login_password: m.login_password,
				permission: m.permission,
				name: m.name,
				tel: m.tel,
				remarks: m.remarks,
				void: m.void,
				classes: m.classes,
				color_code: m.color_code,
				is_updated: m.is_updated ? 1 : 0,
			};
		});
		
		let hash_additional = state.master.data_additional.map(m => {
			return m.asHash();
		});
		
		let hash_pinned = {};
		for (let project_id in state.master.data_project_pinned) {
			hash_pinned[project_id] = {};
			for (let type in state.master.data_project_pinned[project_id]) {
				hash_pinned[project_id][type] = {};
				for (let pinned_id in state.master.data_project_pinned[project_id][type]) {
					hash_pinned[project_id][type][pinned_id] = state.master.data_project_pinned[project_id][type][pinned_id] ? 1 : 0;
				}
			}
		}
		
		return {
			member: hash_member,
			class: state.master.data_class,
			color: state.master.data_color,
			additional: hash_additional,
			list_project: hash,
			list_calendar: state.calendar.list,
			dataset_id: state.dataset_id,
			socketio_id: state.socketio.socketio_id,
			delete_project: state.delete_project,
			pinned: hash_pinned,
		};
	},
	datasetID: function(state) {
		return state.dataset_id;
	},
	listCalendar: function(state) {
		return state.calendar.list;
	},
	isUpdated: function(state) {
		for (let i = 0; i < state.list_project.length; i++) {
			if(state.list_project[i].is_updated) {
				return true;
			}
		}
		
		return false;
	},
	isUpdatedMemberList: function(state) {
		for (let i = 0; i < state.master.data_member.length; i++) {
			if(state.master.data_member[i].is_updated) {
				return true;
			}
		}
		
		return false;
	},
	masterClass: function(state) {
		return state.master.data_class;
	},
	masterColor: function(state) {
		return state.master.data_color;
	},
	progressRate: function(state) {
		return (schedule) => {
			let project;
			for (let p = 0; p < state.list_project.length; p++) {
				if(state.list_project[p].code == schedule.project_code)
					project = state.list_project[p];
			}
			
			let member;
			for (let m = 0; m < project.children.length; m++) {
				if(project.children[m].code == schedule.member_code)
					member = project.children[m];
			}
			let progress_rate;
			for (let i = 0; i < member.schedules.length; i++) {
				if(member.schedules[i].code == schedule.code)
					progress_rate = member.schedules[i].progress_rate;
			}
			
			return progress_rate;
		};
	},
	datasetManager: function(state) {
		return state.dataset_manager;
	},
	scheduleFilter: function(state) {
		return state.schedule_filter;
	},
	scheduleFilterAsHash: function(state) {
		let json = clonedeep(state.schedule_filter);
		let additional_info_data = [];
		state.schedule_filter.additional_info_data.map(data => {
			const data_additional = state.master.data_additional.filter(additional => {
				return additional.code == data.code;
			});
			if (data_additional.length > 0) {
				let additional_json = {
					code: data.code,
				};
				if (data_additional[0].isNumber) {
					additional_json.name = '';
					additional_json.value = {};
					if (data.min)
						additional_json.value.min = Number(data.min);
					if (data.max)
						additional_json.value.max = Number(data.max);
				} else {
					additional_json.name = data.name;
					additional_json.value = null;
				}
				additional_info_data.push(additional_json);
			}
		});
		json.additional_info_data = additional_info_data;

		return json;
	},
	isFiltering: function(state) {
		let filter = state.schedule_filter;
		return !(filter.begin == null && 
					filter.end == null && 
					filter.projects.length == 0 && 
					filter.members.length == 0 && 
					filter.classes.length == 0 && 
					filter.color_project.length == 0 && 
					filter.color_member.length == 0 && 
					filter.additional_info_data.length == 0 && 
					!filter.alert);
	},
	projectList: function(state) {
		return state.list_project;
	},
	isDuplicateLoginId: function(state) {
		return (id) => {
			let login_id = id;
			let m = state.master.data_member.filter(m => { return m.login_id === login_id });
			return m.length > 0;
		};
	},
	filteringChildlen: (state, getters) => (list, parent_alert) => {
		if (getters.displayListType === DISPLAY_LIST_TYPE.PROJECT) {
		
			let filtered_children = list_project_children_filter(list, {
				begin:state.schedule_filter.begin,
				end:state.schedule_filter.end,
				parent: state.schedule_filter.projects,
				children: state.schedule_filter.members,
				classes: state.schedule_filter.classes,
				color_project: state.schedule_filter.color_project,
				color_member: state.schedule_filter.color_member,
				alert:state.schedule_filter.alert,
				status:state.schedule_filter.status,
				additional_info_data:state.schedule_filter.additional_info_data,
			});
			if(parent_alert || !state.schedule_filter.alert)
				return filtered_children;
			
			return filtered_children.filter((item) => {
				if (!item.alert)
					return false;
				return true;
			});
		} else {
			let filtered_children =  list_member_children_filter(list, {
				begin:state.schedule_filter.begin,
				end:state.schedule_filter.end,
				parent: state.schedule_filter.members,
				children: state.schedule_filter.projects,
				classes: state.schedule_filter.classes,
				color_project: state.schedule_filter.color_project,
				color_member: state.schedule_filter.color_member,
				alert:state.schedule_filter.alert,
				status:state.schedule_filter.status,
				additional_info_data:state.schedule_filter.additional_info_data,
			});
			
			if(state.schedule_filter.status == FILTERING_STATUS.ALL)
				return filtered_children;
			
			return filtered_children.filter( (item) => {
				if(state.schedule_filter.status == FILTERING_STATUS.DONE && item.status != Member.STATUS.DONE)
					return false;
				else if(state.schedule_filter.status == FILTERING_STATUS.PROGRESS && item.status != Member.STATUS.PROGRESS)
					return false;
				
				return true;
			});
		}
	},
	filteringSchedules: (state, getters) => (list, children) => {
		if (getters.displayListType === DISPLAY_LIST_TYPE.PROJECT) {
			return list_project_schedule_filter(list, {
				begin:state.schedule_filter.begin,
				end:state.schedule_filter.end,
				parent: state.schedule_filter.projects,
				children: state.schedule_filter.members,
				classes: state.schedule_filter.classes,
				color_project: state.schedule_filter.color_project,
				color_member: state.schedule_filter.color_member,
				alert:state.schedule_filter.alert,
				status:state.schedule_filter.status,
				additional_info_data:state.schedule_filter.additional_info_data,
			});
		} else {
			let filtered_schedule = list_member_schedule_filter(list, {
				begin:state.schedule_filter.begin,
				end:state.schedule_filter.end,
				parent: state.schedule_filter.members,
				children: state.schedule_filter.projects,
				classes: state.schedule_filter.classes,
				color_project: state.schedule_filter.color_project,
				color_member: state.schedule_filter.color_member,
				alert:state.schedule_filter.alert,
				status:state.schedule_filter.status,
				additional_info_data:state.schedule_filter.additional_info_data,
			});
			
			if(state.schedule_filter.status != FILTERING_STATUS.ALL && children != null && children.length > 0) {
				return filtered_schedule.filter((item) => {
					for (let c of children) {
						if(c.code == item.project_code) {
							if(state.schedule_filter.status == FILTERING_STATUS.PROGRESS && c.status == Project.STATUS.PROGRESS)
								return true;
							if(state.schedule_filter.status == FILTERING_STATUS.DONE && c.status == Project.STATUS.DONE)
								return true;
							
							return false;
						}
					}
					return false;
				});
			}
			
			return filtered_schedule;
		}
	},
	canUndo: (state) => {
		return state.dataset_manager.canUndo;
	},
	canRedo: (state) => {
		return state.dataset_manager.canRedo;
	},
	displayPeriod: (state) => {
		if (state.calendar.tick === CALENDAR_TICK.TERM)
			return {
				default: DISPLAY_PERIOD.DEFAULT.TERM,
				expand: DISPLAY_PERIOD.EXPAND.TERM,
				offset: DISPLAY_PERIOD.OFFSET.TERM,
			};
		if (state.calendar.tick === CALENDAR_TICK.DAY)
			return {
				default: DISPLAY_PERIOD.DEFAULT.DAY,
				expand: DISPLAY_PERIOD.EXPAND.DAY,
				offset: DISPLAY_PERIOD.OFFSET.DAY,
			};
		if (state.calendar.tick === CALENDAR_TICK.WEEK)
			return {
				default: DISPLAY_PERIOD.DEFAULT.WEEK,
				expand: DISPLAY_PERIOD.EXPAND.WEEK,
				offset: DISPLAY_PERIOD.OFFSET.WEEK,
			};
	},
	displayPeriodMargin: () => {
		return (tick) => {
			if (tick === CALENDAR_TICK.TERM){
				return DISPLAY_PERIOD.MARGIN.TERM;
			}
			if (tick === CALENDAR_TICK.DAY){
				return DISPLAY_PERIOD.MARGIN.DAY;
			}
			if (tick === CALENDAR_TICK.WEEK){
				return DISPLAY_PERIOD.MARGIN.WEEK;
			}
		};
	},
	listMember: (state) => {
		return state.list_member;
	},
	isAdmin: (state) => {
		return _hasPermission(state, PERMISSION.TYPE.ADMIN);
	},
	isViewer: (state) => {
		return _hasPermission(state, PERMISSION.TYPE.VIEWER);
	},
	isWorkerRole: (state, getters) => {
		return !getters.isAdmin && !getters.isViewer;
	},
	hasPermission: (state) => {
		return (pms) => {
			return _hasPermission(state, pms);
		};
	},
	adminMember: (state) => {
		return state.master.data_member.filter(m => {
			return (m.permission & PERMISSION.TYPE.ADMIN) > 0;
		});
	},
	workerMember: (state) => {
		return member_worker_filter(state.master.data_member);
	},
	memberFilter: (state) => {
		return state.member_filter;
	},
	isFilteringMemberList: (state) => {
		return (state.member_filter.begin
				|| state.member_filter.end
				|| state.member_filter.classes.length > 0);
	},
	filteredMemberList: (state, getters) => (members, ex_members) => {
		let ret = [];
		members.map((item) => {
			ret.push({ member: item, alert: false });
		});
		if (!state.member_filter)
			return ret;

		if (state.member_filter.begin && state.member_filter.end) {
			ret= ret.filter((row) => {
				let member = getters.memberData(row.member.code);
				if (!member) return true;
				
				let merged_schedules = ScheduleListRow.createMergedSchedule(member.schedules);
				let filter_schedules = []; 
				filter_schedules.push(new Schedule({
					code: undefined,
					project_code: undefined,
					member_code: row.member.code,
					begin: new ScheduleTick({code: state.member_filter.begin.replace(/-/g, '') + state.member_filter.begin_term}),
					end: new ScheduleTick({code: state.member_filter.end.replace(/-/g, '') + state.member_filter.end_term}),
					progress_rate: 0,
					color_code: row.member.color_code,
				}));
				let alerts = ScheduleListRow.createOverlapSchedules(merged_schedules, filter_schedules);
				if( alerts && alerts.length === 0) return true;
				
				let merged = new Array();
				alerts.forEach(s => {
					ScheduleListRow.anotherMergeSchedule(merged, s.clone());
				});
				if( merged && merged.length === 0) return true;
				let ex_member;
				if (ex_members)
					ex_member = ex_members.filter(e => { return e.code === member.code})[0];
				row.alert = (!ex_member) ? true : false;
				if(merged[0].begin.code == filter_schedules[0].begin.code
					&& merged[0].end.code == filter_schedules[0].end.code) {
						return ex_member;
				}
				return true;
			});
		}

		if (state.member_filter.classes && state.member_filter.classes.length > 0) {
			ret= ret.filter((row) => {
				let matched = false;
				row.member.classes.forEach((c) => {
					state.member_filter.classes.some((filter_class) => {
						if (c.code == filter_class.code) {
							matched = true;
							return true;
						}
						return false;
					});
				});
				if (!ex_members || matched) return matched;
				let ex_member = ex_members.filter(e => { return e.code === row.member.code})[0];
				return ex_member;
			});
		}

		return ret;
	},
	saveDisplayLeftDay: (state) => {
		return state.save_display_left_day;
	},
	displayColor: (state) => (code, type) => {
		let color = state.master.data_color.find(c => c.code === code);
		if (color === undefined)
			color = state.master.data_color.find(c => c.type === type && c.default_value);
		return new Color(Object.assign(Object.assign({}, color)));
	},
	defauleColorCode: (state) => (type) => {
		return state.master.data_color.find(c => c.type === type && c.default_value).code;
	},
	isExistColor: (state) => (code) => {
		let color = state.master.data_color.find(c => c.code === code);
		if (color === undefined)
			return false;
		return true;
	},
	additionalInfo: (state) => {
		return state.master.data_additional;
	},
	projectPinned: (state) => (id) => {
		return state.master.data_project_pinned[id];
	},
};

const array_reset = (array) => {
	array.splice(0, array.length);
};

const array_remove = (array, item, equation) => {
	if (equation === undefined)
		equation = (a, b) => { return a === b };
	let ret = null;
	array.some((v, i) => {
		if (equation(v, item)) {
			array.splice(i, 1);
			ret = item;
		}
	});
	return ret;
};

const arrayFindLastIndex = (array, callback) => {
	let index = array.slice().reverse().findIndex(callback);

	if (index < 0)
		return -1;
	return array.length - index - 1;
};

const arrayMoveTo = (array, a, b) =>{
	if (a === b){
		return;
	}
	let index_a = array.indexOf(a);
	let index_b = array.indexOf(b);
	let offset = 0;
	let list_from = 0;
	let list_to = 0;
	if(index_a < 0 || index_b < 0){
		return false;
	}
	
	if (index_a < index_b){
		offset = 1;
		list_from = index_a;
		list_to = index_b;
	} else {
		list_from = index_b;
		list_to = index_a;
	}
	
	let swap = a.seq;
	a.seq = b.seq;
	b.seq = swap;
	array_remove (array, a);
	index_b = array.indexOf(b);
	array.splice(index_b + offset , 0, a);
	
	let seqs = [];
	
	for(let i = list_from;i<=list_to;i++){
		seqs.push(array[i].seq);
		
	}
	
	seqs.sort(
		function(a,b){
			return (a < b ? -1 : 1);
		}
	);
	
	for(let i = 0 ;i < seqs.length;i++){
		let obj = array[list_from + i];
		obj.seq = seqs[i];
		if ("is_updated" in obj){
			obj.is_updated = true;
		}
	}
	
	return true;
}

const arrayReplace = (array, a, b) =>{
	let start = array.indexOf(a);
	if (start >= 0){
		array.splice(start,1,b);
		return true;
	}else{
		return false;
	}
}
const memberMoveToTop = (array, a) =>{
    let index_a = array.indexOf(a);

    if(index_a < 0){
        return false;
    }
	
	_memberMoveTo(array, index_a, 0, false);
    
    return true;        
}

const memberMoveTo = (array, a, b) =>{
    let index_a = array.indexOf(a);
    let index_b = array.indexOf(b);
    if(index_a < 0 || index_b < 0){
        return false;
    }
	if (index_a < index_b) {
		_memberMoveTo(array, index_a, index_b, false);
	} else {
		_memberMoveTo(array, index_a, index_b, true);
	}
  
   
    return true;        
}

const _memberMoveTo = (array, src, dest, next) =>{
	let loop_start = 0;
	let loop_end = 0;
	let offset = next ? 1: 0;

	if ( src === dest)
		return;

	if (src < dest){
		loop_start = src;
		loop_end = dest;
		
	} else {
		loop_start = dest;
		loop_end = src;
	}
	
   let src_obj = array[src];
    array_remove (array, src_obj);
    array.splice(dest + offset, 0, src_obj);
    //seqつけなおし
	
    let seqs = [];
	
    for(let i = loop_start;i <= loop_end; i++){
        seqs.push(array[i].seq);
  
    }
	
	seqs.sort((a,b) => { return (a < b ? -1 : 1);}
    );
    for(let i = 0 ;i < seqs.length;i++){
        let obj = array[loop_start + i];
        obj.seq = seqs[i];
        if ("is_updated" in obj){
            obj.is_updated = true;
        }
    }
   
    return true;        
}

const removeProjectFromMember = (state, member, project) => {
	const equalsCode = (a, b) => { return a.code === b.code };
	if (array_remove(member.projects, project, equalsCode)) {
		/* remove schedule */
		let m = state.list_member.filter(m => { return m.code === member.code })[0];
		if (m !== undefined) {
			member.schedules.forEach(s => {
				array_remove(m.schedules, s, (a, b) => {
					return (a.project_code === b.project_code) && (a.member_code === b.member_code);
				});
			});
			array_remove(m.projects, project, equalsCode);
			if (m.projects.length == 0) {
				array_remove(state.list_member, m);
				delete state.list_row_state[DISPLAY_LIST_TYPE.MEMBER][m.code];
			}
		}
	}
};
const changeRowStatus = (state, row, parent) => {
	if (row.isProject) {
		row.is_updated = true;
	} else if (row.isMember) {
		if (!parent || !parent.isProject)
			throw "Need parent.";

		let member = state.list_member.filter(m => m.code === row.code)[0];
		member.projects.filter(p => p.code === parent.code).forEach(p => {
			p.status = row.status;
		});
		parent.is_updated = true;
	}
};

const _createCalendarYearmonth = (state) => {
	let items = new Array();
	let ym; 
	
	for (let cal of state.calendar.list) {
		let code_ym = cal.code.substr(0, 6);
		if ((ym === undefined) || (ym.code !== code_ym)) {
			ym = {
				code: code_ym,
				yearmonth: code_ym,
				ym: code_ym.substr(0, 4) + "年" + parseInt(code_ym.substr(4, 2)) + "月",
				days: [],
				terms: [],
				weeks: [],
			};
			items.push(ym);
		}
		let code_day = cal.code.substr(0, 8);
		let week = Week.fromYMD(cal.code, cal.week);
		ym.terms.push(new Term({
			code: code_day + ScheduleTick.TERM.AM,
			weekDayNum: cal.week,
			holiday: cal.holiday,
		}));
		ym.terms.push(new Term({
			code: code_day + ScheduleTick.TERM.PM,
			weekDayNum: cal.week,
			holiday: cal.holiday,
		}));
		if ((ym.days.length == 0) || (ym.days[ym.days.length - 1].code !== code_day)) {
			ym.days.push(new Day({
				code: code_day,
				weekDayNum: cal.week,
				holiday: cal.holiday,
			}));
		}
		if (ym.code !== week.code.substr(0, 6))
			continue;
		if ((ym.weeks.length == 0) || (ym.weeks[ym.weeks.length - 1].code !== week.code)) {
			ym.weeks.push(week);
		}
	}
	state.calendar.yearmonth = items;
};
const _createScheduleListRowState = (list_row_state, {code, is_expanded}) => {
	if (list_row_state[code] !== undefined)
		return;
	list_row_state[code] = {
		code: code,
		is_expanded: is_expanded,
	};
};
const _setExpandedScheduleListRowState = (state, list_type, {code, is_expanded}) => {
	let list_row_state = state.list_row_state[list_type];
	let row = list_row_state[code];
	if (row === undefined)
		return false;

	Vue.set(row, 'is_expanded', is_expanded);
	Vue.set(list_row_state, code, row);
	Vue.set(state.list_row_state, list_type, list_row_state);

	return true;
};

const resetIsUpdated = (array) => {
	array.forEach(row => {
		row.is_updated = false;
	});
};

const _createListMember = (state) => {
	let members = {};
	for (let p of state.list_project) {
		for (let m of p.children) {
			if (members[m.code] === undefined) {
				m.children.length = 0;
				members[m.code] = new Member(m);
				members[m.code].schedules = [];
				members[m.code].alert = m.alert;
			}
			for (let s of m.schedules)
				members[m.code].schedules.push(s);
				members[m.code].alert = members[m.code].alert || m.alert;
			let project = new Project(p);
			project.schedules = m.schedules;
			project.status = m.status;
			members[m.code].projects.push(project);
		}
	}
	
	let values = Object.values(members);
	values.sort((a, b) => {
		let seq_a = state.master.data_member.filter((m) => m.code === a.code)[0];
		let seq_b = state.master.data_member.filter((m) => m.code === b.code)[0];

		if (seq_a === undefined)
			return 1;
		if (seq_b === undefined)
			return -1;

		return seq_a.seq - seq_b.seq;
	});
	array_reset(state.list_member);
	for (let m of values) {
		state.list_member.push(m);
	}
};

const _setAlertByMemberMove = (state, member_id) => {
	let all_member = new Array();
	let all_schedule = new Array();
	state.list_project.forEach(p => {
		p.members.forEach(m => {
			if (m.code === member_id) {
				all_member.push({item: m, parent: p});
				m.schedules.forEach(s => {
					all_schedule.push(s);
				});
			}
		});
	});
	all_member.forEach(m => {
		let alerts = ScheduleListRow.createOverlapSchedules(all_schedule, m.item.schedules);
		if (alerts && alerts.length > 0 && !m.item.alert) {
			m.item.alert = true;
			m.item.is_updated = true;
			m.parent.is_updated = true;
		} else if ((!alerts || alerts.length == 0) && m.item.alert) {
			m.item.alert = false;
			m.item.is_updated = true;
			m.parent.is_updated = true;
		}
	});

	let member = state.list_member.filter(m => { return m.code === member_id })[0];
	if (member !== undefined) {
		let alerts = member.createOverlapSchedules(member.schedules);
		let alert = (alerts && alerts.length > 0);
		member.alert = alert;
		member.projects.forEach(p =>{
			p.alert = alert;
		});
	}
};

const _isAllExpand = (list_row_state) => {
	return !Object.keys(list_row_state).map(key => list_row_state[key]).some(row_state => row_state.is_expanded);
};

const _findParentFromListProject = (project_code, member_code) => {
	let project = state.list_project.filter(p => p.code === project_code)[0];
	if (project === undefined) {
		consoleWarn('no such project. ' + project_code);
		return undefined;
	}

	let parent;
	if (member_code) {
		let member = project.members.filter(m => m.code === member_code)[0];
		parent = member;
	} else {
		parent = project;
	}

	if (parent === undefined) {
		consoleWarn(`no such parent. project_code: ${project_code}, member_code: ${member_code}`);
		return undefined;
	}

	return {
		project: project,
		parent: parent,
	};
};

const _findScheduleFromListProject = (schedule_code, project_code, member_code) => {
	let found = _findParentFromListProject(project_code, member_code);
	if (found === undefined)
		return undefined;

	let schedule = found.parent.schedules.filter(s => s.code === schedule_code)[0];
	if (schedule === undefined) {
		consoleWarn('no such schedule.' + schedule_code);
		return undefined;
	}

	return {
		schedule: schedule,
		project: found.project,
		parent: found.parent,
	};
};

const _existsMasterClass = (c) => {
	return state.master.data_class.some(master => master.code === c.code);
};

const mutations = {
	initState: function(state) {
		state.mode = MODE.VIEW;
		state.display_list_type = DISPLAY_LIST_TYPE.PROJECT;
		state.is_all_expanded = true;
		state.is_scrolling_to_today = false;
		// size
		state.size.width = 0;
		state.size.height = 0;
		// position
		state.position.hscroll = 0;
		// master
		array_reset(state.master.data_member);
		array_reset(state.master.data_class);
		// list_row_state
		for(let i = 0; i < state.list_row_state.length; i++)
			state.list_row_state[i] = {};
		// list_data_state
		state.list_data_state.project = [];
		state.list_data_state.member = [];

		array_reset(state.list_project);
		array_reset(state.list_member);
		array_reset(state.delete_project);
		state.calendar.tick = CALENDAR_TICK.DAY;
		array_reset(state.calendar.list);
		state.calendar.yearmonth = null;

		// state.loading = true;	// ignore 
		array_reset(state.notifications);
		state.dataset_id = null;
		state.exclusive  = false;
		// token
		state.access_token = null;
		state.refresh_token = null;
		// socketio
		state.socketio.socketio = null;
		state.socketio.socketio_id = null;
		state.socketio.listener = {};
		// dataset
		if (state.dataset_manager)
			state.dataset_manager.reset();
		// schedule_filter
		state.schedule_filter.begin = null;
		state.schedule_filter.end = null;
		array_reset(state.schedule_filter.projects);
		array_reset(state.schedule_filter.members);
		array_reset(state.schedule_filter.classes);
		array_reset(state.schedule_filter.color_project);
		array_reset(state.schedule_filter.color_member);
		array_reset(state.schedule_filter.additional_info_data);
		state.schedule_filter.alert = false;
		state.schedule_filter.status = FILTERING_STATUS.PROGRESS;

		// member_filter
		state.member_filter.begin = null;
		state.member_filter.begin_term = null;
		state.member_filter.end = null;
		state.member_filter.end_term = null;
		state.member_filter.classes = [];

		state.reset_passwd = false;
		state.save_display_left_day = null;
	},
	toggleBoardLeftPosition: function(state) {
		if (state.position.board_left === 0)
			state.position.board_left = -160;
		else
			state.position.board_left = 0;
	},
	createData: function(state, response) {
		stock_members = new Array();
		state.master.data_member = response.member;
		state.master.data_class = response.class;
		state.master.data_color = response.color;
		state.master.data_additional = createAddtional(response.additional);
		state.master.data_project_pinned = createProjectPinned(response.pinned);
		state.list_project = response.list_project.map(p => {
			_createScheduleListRowState(state.list_row_state[DISPLAY_LIST_TYPE.PROJECT], {
				code: p.code,
				is_expanded: !!p.is_expanded,
			});
			let status;
			switch (p.status) {
				case 0:
				status = Project.STATUS.UNKNOWN;
				break;
				case 1:
				status = Project.STATUS.PROGRESS;
				break;
				case 2:
				status = Project.STATUS.DONE;
				break;
			}
			return new Project({
				code: p.code,
				seq: p.seq,
				name: p.name,
				status: status,
				alert: (p.alert != 0),
				remarks: p.remarks,
				classes: createClasses(p.code, Class.RELATION_TYPE.PROJECT, p.classes),
				schedules: createSchedule(p.schedules),
				members: createMembers(p.children),
				color_code: p.color_code,
				project_additional: p.project_additional,
				is_updated: (p.is_updated != 0),
			});
		});

		_createListMember(state);
		state.calendar.list = response.list_calendar;
		state.dataset_id = response.dataset_id;
		state.delete_project = [];
		_createCalendarYearmonth(state);
	},
	addExtendedData: function(state, params) {
		if (params.is_expand_forward) {
			state.calendar.list = params.response.list_calendar.concat(state.calendar.list);
		} else {
			state.calendar.list = state.calendar.list.concat(params.response.list_calendar);
		}
		if (params.all_period) {
			let begin = strftime('%Y%m%d', params.all_period.begin);
			let end = strftime('%Y%m%d', params.all_period.end);

			// 期間の切りつめ
			let index;
			index = arrayFindLastIndex(state.calendar.list, (item) => {
				return item.code < begin;
			});
			if (index >= 0)
				state.calendar.list.splice(0, index + 1);

			index = state.calendar.list.findIndex((item) => {
				return end < item.code;
			});
			if (index >= 0)
				state.calendar.list.splice(index, state.calendar.list.length - index);
		}
		_createCalendarYearmonth(state);

		let notExistState = state.list_project.length == 0;
		params.response.list_project.map(p => {
			_createScheduleListRowState(state.list_row_state[DISPLAY_LIST_TYPE.PROJECT], {
				code: p.code,
				is_expanded: !!p.is_expanded,
			});
			let status;
			switch (p.status) {
				case 0:
				status = Project.STATUS.UNKNOWN;
				break;
				case 1:
				status = Project.STATUS.PROGRESS;
				break;
				case 2:
				status = Project.STATUS.DONE;
				break;
			}
			let add_project =  new Project({
				code: p.code,
				seq: p.seq,
				name: p.name,
				status: status,
				alert: (p.alert != 0),
				remarks: p.remarks,
				classes: createClasses(p.code, Class.RELATION_TYPE.PROJECT, p.classes),
				schedules: createSchedule(p.schedules),
				members: createMembers(p.children),
				color_code: p.color_code,
				project_additional: p.project_additional,
				is_updated: (p.is_updated != 0),
			});
			if (notExistState) {
				state.list_project.push(add_project);
				return;
			}

			let push = true;
			state.list_project.some((project, i) => {
				if (p.seq > project.seq) return false;
				push = false;
				array_remove(state.list_project, add_project, (a, b) => {
					return a.code == b.code;
				});					
				state.list_project.splice(i, 0, add_project);

				return true;
			});
			if (push)
				state.list_project.push(add_project);
		});
		if (params.all_period) {
			let begin = strftime('%Y%m%d', params.all_period.begin);
			let end = strftime('%Y%m%d', params.all_period.end);
			// 期間の切りつめ
			state.list_project.concat().forEach(p => {
				if (p.schedules.length == 0)
					return;

				let max = parseInt(new String(Math.max(...p.schedules.map((s) => s.end.code))).substring(0, 8));
				let min = parseInt(new String(Math.min(...p.schedules.map((s) => s.begin.code))).substring(0, 8));
				if (max < begin || end < min) {
					array_remove(state.list_project, p);
				}
			});
		}
		
		_createListMember(state);
	},
	hscroll: function (state, hscroll) {
		if (hscroll === undefined || hscroll < 0)
			hscroll = 0;
		state.position.hscroll = hscroll;
	},
	setWindowSize: function(state, size) {
		state.size.width = size.width;
		state.size.height = size.height;
	},
	toggleExpand: function (state, {is_project, code}) {
		let list_type = is_project ? DISPLAY_LIST_TYPE.PROJECT
		                           : DISPLAY_LIST_TYPE.MEMBER;
		let list_row_state = state.list_row_state[list_type];
		_setExpandedScheduleListRowState(state, list_type, {
			code: code,
			is_expanded: !list_row_state[code].is_expanded,
		});
		state.is_all_expanded = _isAllExpand(list_row_state);
	},
	toggleAllExpand: function (state, list_type) {
		let list_row_state = state.list_row_state[list_type];
		state.is_all_expanded = _isAllExpand(list_row_state);
	},
	setMode: function (state, mode) {
		state.mode = mode;
	},
	setDisplayList: function(state, list_type) {
		state.display_list_type = list_type;
	},
	switchCalendarTick: function(state, tick) {
		state.calendar.tick = tick;
	},
	setExpandedScheduleListRowAll: function(state, {list_type, is_expanded}) {
		let list_row_state = state.list_row_state[list_type];
		Object.keys(list_row_state).forEach(code => {
			_setExpandedScheduleListRowState(state, list_type, {
				code: code,
				is_expanded: is_expanded,
			});
		});
	},
	setScheduleListFilteringAll: function(state) {
		state.list_data_state.project = [];
		state.list_data_state.member = [];
	},
	setStatusDone: function(state, {self_code, parent_code}) {
		let found = parent_code ? _findParentFromListProject(parent_code, self_code)
		                        : _findParentFromListProject(self_code);
		if (found === undefined)
			return;

		found.parent.setStatusDone();
		changeRowStatus(state, found.parent, found.project);
	},
	setStatusProgress: function(state, {self_code, parent_code}) {
		let found = parent_code ? _findParentFromListProject(parent_code, self_code)
		                        : _findParentFromListProject(self_code);
		if (found === undefined)
			return;

		found.parent.setStatusProgress();
		changeRowStatus(state, found.parent, found.project);
	},
	deleteMe: function(state, {project_code}) {
		let project = state.list_project.filter(p => p.code === project_code)[0];
		if (project === undefined) {
			consoleWarn('no such project. ' + project_code);
			return;
		}
		state.list_member.forEach(m => {
			project.members.forEach(pm => {
				if (pm.code === m.code) {
					pm.schedules.forEach(s => {
						array_remove(m.schedules, s, (a, b) => {
							return (a.project_code === b.project_code) && (a.member_code === b.member_code);
						});
					});
				}
			});
			array_remove(m.projects, project, (a, b) => {
				return a.code == b.code;
			});
		});
		state.list_member = state.list_member.filter(m => {
			return m.projects.length > 0;
		});
		array_remove(state.list_project, project, (a, b) =>{ 
			return a.code === b.code;
		});
		delete state.list_row_state[DISPLAY_LIST_TYPE.PROJECT][project.code];
		state.is_all_expanded = _isAllExpand(state.list_row_state[DISPLAY_LIST_TYPE.PROJECT]);
		state.delete_project.push({code: project.code});
		project.members.forEach(pm => {
			_setAlertByMemberMove(state, pm.code);
		});
	},
	addMemberToProject: function(state, {member_code, project_code}) {
		let project = state.list_project.filter(p => p.code === project_code)[0];
		if (project === undefined) {
			consoleWarn('no such project. ' + project_code);
			return;
		}
		let member = member_worker_filter(state.master.data_member).filter(m => m.code === member_code)[0];
		if (member === undefined) {
			consoleWarn('no such member. ' + member_code);
			return;
		}

		let default_color = state.master.data_color.find(c => c.type === Color.RELATION_TYPE.MEMBER && c.default_value);
		let schedules = project.schedules.map(s => {
			let member_schedule = clonedeep(s);
			member_schedule.code = undefined;
			member_schedule.member_code = member.code;
			member_schedule.progress_rate = 0;
			member_schedule.color_code = default_color.code;
			return new Schedule(member_schedule);
		});

		let projects = state.list_project.filter(p => {
			if (p.code === project.code)
				return true;
			let project_member = p.children.filter(m => { return m.code === member.code })[0];
			if (project_member !== undefined)
				return true;
			return false;
		});

		let seq = 1;
		if (project.members.length > 0)
			seq = Math.max(...project.members.map(m => m.seq)) + 1;
		let projectMember = new Member(Object.assign(Object.assign({}, member), {
			seq: seq,
			status: Member.STATUS.PROGRESS,
			alert: false,
			classes: createClasses(member.code, Class.RELATION_TYPE.MEMBER, member.classes),
			schedules: schedules,
			projects: projects,
			color_code: member.color_code,
			is_expanded: true,
		}));

		_createScheduleListRowState(state.list_row_state[DISPLAY_LIST_TYPE.MEMBER], {
			code: projectMember.code,
			is_expanded: true,
		});
		state.list_data_state.member.push({
			project_code:project.code,
			member_code:member.code,
		});
		state.list_project.some(p => {
			if (p.code !== project.code)
				return false;
			let project_member = p.children.filter(m => { return m.code === member.code })[0];
			if (project_member !== undefined)
				return true;
			p.children.push(projectMember);
			p.is_updated = true;
			let alerts = p.createOverChildrenSchedules();
			p.alert = (alerts && alerts.length > 0) ? true : false;
			return true;
		});
		_createListMember(state);
		_setAlertByMemberMove(state, member.code);
	},
	deleteMemberFromProject: function(state, {member_code, project_code}) {
		let project = state.list_project.filter(p => { return p.code === project_code })[0];
		if (project === undefined) {
			consoleWarn('no such project. ' + project_code);
			return;
		}
		let member = project.members.filter(m => { return m.code === member_code })[0];
		if (member === undefined) {
			consoleWarn('no such member. ' + member_code);
			return;
		}

		removeProjectFromMember(state, member, project);
		array_remove(project.members, member);
		const equalsCode = (a, b) => a.project_code === b.project_code && a.member_code === b.member_code;
		array_remove(state.list_data_state.member, {
			project_code: project.code,
			member_code: member.code,
		}, equalsCode);

		state.list_project.some(p => {
			if(p.code !== project.code) return false;
			p.is_updated = true;
			let alerts = p.createOverChildrenSchedules();
			p.alert = (alerts && alerts.length > 0) ? true : false;
			return true;
		});
		
		_setAlertByMemberMove(state, member.code);
	},

	updateSchedule: function(state, {schedule_code, project_code, member_code, begin_code, end_code}) {
		let found = _findScheduleFromListProject(schedule_code, project_code, member_code);
		if (found === undefined)
			return;

		if (begin_code)
			found.schedule.begin.code = begin_code;
		
		if (end_code)
			found.schedule.end.code = end_code;
		
		found.project.is_updated = true
		let alerts = found.project.createOverChildrenSchedules();
		found.project.alert = (alerts && alerts.length > 0) ? true : false;
		
		if (member_code)
			_setAlertByMemberMove(state, member_code);
	},
	updateProgressRate: function(store, {schedule_code, project_code, member_code, progress_rate}) {

		let found = _findScheduleFromListProject(schedule_code, project_code, member_code);
		if (found === undefined)
			return;

		found.schedule.progress_rate = progress_rate;
		found.project.is_updated = true;
	},
	updateScheduleTitle: function(store, {schedule_code, project_code, member_code, title}) {
		let found = _findScheduleFromListProject(schedule_code, project_code, member_code);
		if (found === undefined)
			return;

		found.schedule.title = title;
		found.project.is_updated = true;
	},
	updateScheduleColor: function(store, {schedule_code, project_code, member_code, color_code}) {
		let found = _findScheduleFromListProject(schedule_code, project_code, member_code);
		if (found === undefined)
			return;

		found.schedule.color_code = color_code;
		found.project.is_updated = true;
	},
	setScrollingToToday: function(state, scrolling) {
		state.is_scrolling_to_today = scrolling;
	},
	setShowFreePerson: function(state, bool) {
		state.is_show_freeperson = bool;
	},
	deleteScheduleFromParent: function(state, {schedule_code, project_code, member_code}) {
		let found = _findScheduleFromListProject(schedule_code, project_code, member_code);
		if (found === undefined)
			return;

		array_remove(found.parent.schedules, found.schedule);
		if (found.parent.isMember) {
			let member = state.list_member.filter((m) => {
				return m.code === found.parent.code;
			})[0];
			array_remove(member.schedules, found.schedule, (a, b) => {
				return (a.project_code === b.project_code) && (a.code === b.code);
			});
		}
		
		found.project.is_updated = true;
		let alerts = found.project.createOverChildrenSchedules();
		found.project.alert = (alerts && alerts.length > 0) ? true : false;
		
		if (found.schedule.member_code)
			_setAlertByMemberMove(state, found.schedule.member_code);
	},
	addSchedule: function(state, {schedule}) {
		let found = _findParentFromListProject(schedule.project_code, schedule.member_code);
		if (found === undefined)
			return;

		found.parent.schedules.push(schedule);
		if (found.parent.isMember) {
			let member = state.list_member.filter((m) => {
				return m.code === found.parent.code;
			})[0];
			member.schedules.push(schedule);
		}
		found.project.is_updated = true;
		let alerts = found.project.createOverChildrenSchedules();
		found.project.alert = (alerts && alerts.length > 0) ? true : false;
		
		if (schedule.member_code)
			_setAlertByMemberMove(state, schedule.member_code);
	},
	listProjectMemberMoveTo: function(state, {project_code, src_code, dst_code}){
		let project = state.list_project.filter(p => p.code === project_code)[0];
		if (project === undefined) {
			consoleWarn('no such project. ' + project_code);
			return;
		}
		let src = project.members.filter(m => m.code === src_code)[0];
		if (src === undefined) {
			consoleWarn('no such src member. ' + src_code);
			return;
		}
		let dst = project.members.filter(m => m.code === dst_code)[0];
		if (dst === undefined) {
			consoleWarn('no such dst member. ' + dst_code);
			return;
		}

		arrayMoveTo(project.members, src, dst);
		project.is_updated = true;
	},
	listProjectMoveTo: function(state, {src_code, dst_code}){
		let src = state.list_project.filter(p => p.code === src_code)[0];
		if (src === undefined) {
			consoleWarn('no such src project. ' + src_code);
			return;
		}
		let dst = state.list_project.filter(p => p.code === dst_code)[0];
		if (dst === undefined) {
			consoleWarn('no such dst project. ' + dst_code);
			return;
		}

		arrayMoveTo(state.list_project, src, dst);
		src.is_updated = true;
		dst.is_updated = true;
		_createListMember(state);
	},
	masterMemberMoveTo: function(state, {src_code, dst_code}){
		let src = state.master.data_member.filter(p => p.code === src_code)[0];
		if (src === undefined) {
			consoleWarn('no such src member. ' + src_code);
			return;
		}
		let dst = state.master.data_member.filter(p => p.code === dst_code)[0];
		if (dst === undefined) {
			consoleWarn('no such dst member. ' + dst_code);
			return;
		}
		memberMoveTo(state.master.data_member, src, dst);
		_createListMember(state);
	},
	
	
	masterMemberMoveToTop: function(state, {src_code}){
		let src = state.master.data_member.filter(p => p.code === src_code)[0];
		if (src === undefined) {
			consoleWarn('no such src member. ' + src_code);
			return;
		}
		memberMoveToTop(state.master.data_member, src);
		_createListMember(state);
	},
	startLoading: function(state){
		state.loading = true;
	},
	endLoading: function(state){
		state.loading = false;
	},
	addNotification: function(state, notification){
		if (notification.uniq_type !== null) {
			let notifications = state.notifications;
			let dirty_notification = notifications.filter(n => n.uniq_type == notification.uniq_type)[0];
			if (dirty_notification) {
				if (notification.message === dirty_notification.message) {
					notification.state.count = dirty_notification.state.count + 1;
				}
				arrayReplace(notifications, dirty_notification, notification);
			} else {
				state.notifications.push(notification);
			}
		} else {
			state.notifications.push(notification);
		}
	},
	removeNotification: function(state, notification) {
		array_remove(state.notifications, notification);
	},
	closeSnackbar: function(state) {
		state.notifications = new Array();
	},
	startExclusive: function(state){
		state.exclusive = true;
	},
	endExclusive: function(state){
		state.exclusive = false;
	},
	endPrintSchedule: function(state){
		state.print_schedule = false;
	},
	startPrintSchedule: function(state){
		state.print_schedule = true;
	},
	setAccessToken: function(state, params) {
		state.access_token = params;
		localStorage.setItem('access_token', JSON.stringify(state.access_token));
	},
	getAccessToken: function(state) {
		if(localStorage.getItem('access_token')){
			state.access_token = JSON.parse(localStorage.getItem('access_token'));
		}
	},
	setRefreshToken: function(state, params) {
		state.refresh_token = params;
		localStorage.setItem('refresh_token', JSON.stringify(state.refresh_token));
	},
	getRefreshToken: function(state) {
		if(localStorage.getItem('refresh_token')){
			state.refresh_token = JSON.parse(localStorage.getItem('refresh_token'));
		}
	},
	deleteAccessToken: function(state) {
		localStorage.removeItem('access_token');
		state.access_token = null;
	},
	deleteRefreshToken: function(state) {
		localStorage.removeItem('refresh_token');
		state.refresh_token = null;
	},
	updateDataSetID: function(state, params) {
		state.dataset_id = params;
	},
	socketio_id: function(state, params){
		state.socketio.socketio_id = params;
	},
	socketio: function(state, params){
		state.socketio.socketio = params;
	},
	disconnectSocketIO: function(state) {
		if (state.socketio.socketio)
			state.socketio.socketio.disconnect();
		state.socketio.socketio = null;
		state.socketio.socketio_id = null;
	},
	setUpdate: function(state, params) {
		params.list_project.forEach(p => {
			p.is_updated = true;
		});
	},
	setDataSetManager: function(state, params) {
		state.dataset_manager = params;
	},
	setMasterClasses: function(state, params) {
		const changeValue = (target, values) => {
			target.name = values.name;
		};
		const findAndChangeValues = (array, values) => {
			array.some(item => {
				if (item.code === values.code) {
					changeValue(item, values);
					return true;
				}
				return false;
			});
		};
		const findAndDelete = (array, values) => {
			let index = array.findIndex(v => v.code === values.code);
			if (index !== -1)
				array.splice(index, 1);
		};
		params.forEach(cls => {
			if (!cls.is_updated)
				return;
			let index = state.master.data_class.findIndex(c => c.code === cls.code);
			if (index === -1) {
				state.master.data_class.push(cls);
			} else {
				changeValue(state.master.data_class[index], cls);

				state.list_project.forEach((p) => {
					findAndChangeValues(p.classes, cls);
					p.children.forEach((c) => {
						findAndChangeValues(c.classes, cls);
					});
				});
				state.list_member.forEach((m) => {
					findAndChangeValues(m.classes, cls);
				});
				state.master.data_member.forEach((m) => {
					findAndChangeValues(m.classes, cls);
				});
			}
		});
		let delete_code = [];
		state.master.data_class.forEach(cls => {
			let index = params.findIndex(c => c.code === cls.code);
			if (index !== -1)
				return;

			state.list_project.forEach((p) => {
				findAndDelete(p.classes, cls);
				p.children.forEach((c) => {
					findAndDelete(c.classes, cls);
				});
			});
			state.list_member.forEach((m) => {
				findAndDelete(m.classes, cls);
			});
			state.master.data_member.forEach((m) => {
				findAndDelete(m.classes, cls);
			});
			delete_code.push(cls.code);
		});
		delete_code.forEach(code => {
			state.master.data_class = state.master.data_class.filter(c => c.code !== code);
		});
	},
	setMasterColors: function(state, params) {
		const changeValue = (target, values) => {
			target.name = values.name;
			target.red = values.red;
			target.green = values.green;
			target.blue = values.blue;
		};
		const findAndChangeValues = (target, values) => {
			if (target === values.code)
				target = values.code;
		};
		params.forEach(clr => {
			if (!clr.is_updated)
				return;
			let index = state.master.data_color.findIndex(c => c.code === clr.code);
			if (index === -1) {
				state.master.data_color.push(clr);
			} else {
				changeValue(state.master.data_color[index], clr);

				state.list_project.forEach((p) => {
					findAndChangeValues(p.color_code, clr);
					p.children.forEach((c) => {
						findAndChangeValues(c.color_code, clr);
					});
				});
				state.list_member.forEach((m) => {
					findAndChangeValues(m.color_code, clr);
				});
			}
		});
		state.master.data_color.forEach(clr => {
			let index = params.findIndex(c => c.code === clr.code || c.type !== clr.type);
			if (index !== -1)
				return;

			state.master.data_color = state.master.data_color.filter(c => c.code !== clr.code);
		});
	},
	updateListProject: function(state, params) {
		let index = state.list_project.findIndex(p => p.code === params.code);
		if (index !== -1) {
			let target = state.list_project[index];
			target.name = params.name;
			target.classes = params.classes.filter(_existsMasterClass);
			target.remarks = params.remarks;
			target.is_updated = params.is_updated;
			target.color_code = params.color_code;
			target.project_additional = params.project_additional;
			
			state.list_project.splice(index, 1, target);
			_createListMember(state);
		}
	},
	addListProject: function(state, params) {
		state.list_project.forEach(p => {
			if(p.seq >= params.seq)
				p.seq++;
		});
		params.classes = params.classes.filter(_existsMasterClass);
		let color = state.master.data_color.find(c => c.type === Color.RELATION_TYPE.PROJECT && c.default_value);
		params.color_code = color.code;
		state.list_project.splice(0, 0, params);
		_createScheduleListRowState(state.list_row_state[DISPLAY_LIST_TYPE.PROJECT], {
			code: params.code,
			is_expanded: true,
		});
		state.is_all_expanded = _isAllExpand(state.list_row_state[DISPLAY_LIST_TYPE.PROJECT]);
		state.list_data_state.project.push(params.code);
	},
	updateDataMember: function(state, params) {
		let m = state.master.data_member.filter(m => { return m.code === params.code });
		if(m.length > 0){
			arrayReplace(state.master.data_member, m[0], params);
		}
		const updateMember = m => {
			if(m.code === params.code){
				m.name = params.name;
				m.classes = params.classes.filter(_existsMasterClass).map(cls => new Class({
					code: cls.code,
					name: cls.name,
					relation_type: Class.RELATION_TYPE.MEMBER,
					relation_code: m.code,
				}));
				m.remarks = params.remarks;
				m.tel = params.tel;
				m.color_code = params.color_code;
			}
		};
		state.list_project.forEach(p => {
			p.children.forEach(updateMember);
		});

		state.list_member.forEach(updateMember);
	},
	addDataMembe: function(state, params) {
		let m = state.master.data_member.filter(m => { return m.code === params.code });
		if(m.length === 0){
			params.seq = Math.max(...state.master.data_member.map((m) => m.seq)) + 1;
			params.color_code = state.master.data_color.find(c => c.type === Color.RELATION_TYPE.MEMBER && c.default_value).code;
			state.master.data_member.push(params);
		}
	},
	deleteDataMember: function(state, {member_code}) {
		let m = state.master.data_member.filter(m => { return m.code === member_code });
		if(m.length == 0){
			return;
		}
		array_remove(state.master.data_member, m[0], (a, b) => {
			return a.code == b.code;
		});

		state.list_project = state.list_project.map(p => {
			p.children = p.children.filter(c => { return c.code !== member_code });
			return p;
		});
		
		state.list_member = state.list_member.filter(m => { return m.code !== member_code });
		delete state.list_row_state[DISPLAY_LIST_TYPE.MEMBER][member_code];
	},
	resetDataset: function(state) {
		state.delete_project = [];
		resetIsUpdated(state.list_project);
		resetIsUpdated(state.list_member);
		resetIsUpdated(state.master.data_class);
		resetIsUpdated(state.master.data_member);
	},
	updateScheduleFilter: function(state, params) {
		state.schedule_filter = params;
	},
	setMemberFilter: function(state, params) {
		state.member_filter.begin = params.begin;
		state.member_filter.begin_term = params.begin_term;
		state.member_filter.end = params.end;
		state.member_filter.end_term = params.end_term;
		state.member_filter.classes = params.classes;
	},
	addGanttBoardEventListener: function(state, params) {
		let type = params.type;
		let callback = params.listener;
		let listener = state.socketio.listener;

		if (listener[type] === undefined)
			listener[type] = [];

		listener[type].push(callback);
	},
	removeGanttBoardEventListener: function(state, params) {
		let type = params.type;
		let callback = params.listener;
		let listener = state.socketio.listener;

		if (listener[type]) {
			array_remove(listener[type], callback);
		}
	},
	emitGanttBoardEvent: function(state, params) {
		let type = params.type;
		let data = params.data;
		let listener = state.socketio.listener;

		if (listener[type]) {
			listener[type].forEach(f => {
				f(data);
			});
		}
	},
	setSaveDisplayLeftDay: function(state, params) {
		state.save_display_left_day = params;
	},
	updateProjectPinned: function(state, params) {
		state.master.data_project_pinned[params.code] = params.items;
	},

};

const actions = {
	initState: function({ commit }) { commit('initState') },
	toggleBoardLeftPosition: function({ commit }) {
		commit('toggleBoardLeftPosition');
	},
	hscroll: function(store, hscroll) {
		store.commit('hscroll', hscroll);
	},
	hscrollMove: function(store, amount) {
		if (isNaN(amount))
			return;
		let max = store.getters.innerWidth - (store.state.size.width - store.getters.listWidth);
		let pos = store.state.position.hscroll - amount;
		if (pos < 0)
			pos = 0;
		if (max < pos)
			pos = max;
		store.commit('hscroll', pos);
	},
	setWindowSize: function(store, size) {
		store.commit('setWindowSize', size);
	},
	toggleExpand: function(store, params) {
		store.commit('toggleExpand', params);
	},
	toggleAllExpandProject: function(store) {
		store.commit('toggleAllExpand', DISPLAY_LIST_TYPE.PROJECT);
	},
	toggleAllExpandMember: function(store) {
		store.commit('toggleAllExpand', DISPLAY_LIST_TYPE.MEMBER);
	},
	setModeView: function(store) {
		store.commit('setMode', MODE.VIEW);
	},
	setModeEdit: function(store) {
		store.commit('setMode', MODE.EDIT);
	},
	switchCalendarTick: function({ commit, getters }, val) {
		let ticks = state.position.hscroll / UNIT_WIDTH.TICK * getters.unitTicks;
		let after = ticks * (UNIT_WIDTH.TICK / _unitTicks(val));
		commit('switchCalendarTick', val);
		Vue.nextTick(() => {
			commit('hscroll', after);
		});
	},
	setStatusDone: function(store, params) {
		store.commit('setStatusDone', params);
	},
	setStatusProgress: function(store, params) {
		store.commit('setStatusProgress', params);
	},
	setDisplayListProject: function(store) {
		store.commit('setDisplayList', DISPLAY_LIST_TYPE.PROJECT);
	},
	setDisplayListMember: function(store) {
		store.commit('setDisplayList', DISPLAY_LIST_TYPE.MEMBER);
	},
	foldingListProjectAll: function(store) {
		store.commit('setExpandedScheduleListRowAll', {
			list_type: DISPLAY_LIST_TYPE.PROJECT,
			is_expanded: false,
		});
	},
	foldingListMemberAll: function(store) {
		store.commit('setExpandedScheduleListRowAll', {
			list_type: DISPLAY_LIST_TYPE.MEMBER,
			is_expanded: false,
		});
	},
	deleteMe: function(store, row) {
		let index =  state.list_project.findIndex(p => p.code === row.project_code);
		if (index !== -1) {
			store.commit('deleteMe', row);
			return true;
		}
		
		return false;
	},
	expandingListProjectAll: function(store) {
		store.commit('setExpandedScheduleListRowAll', {
			list_type: DISPLAY_LIST_TYPE.PROJECT,
			is_expanded: true,
		});
	},
	expandingListMemberAll: function(store) {
		store.commit('setExpandedScheduleListRowAll', {
			list_type: DISPLAY_LIST_TYPE.MEMBER,
			is_expanded: true,
		});
	},
	addMemberToProject: function(store, params) {
		let index =  state.list_project.findIndex(p => p.code === params.project_code);
		if(index !== -1) {
			store.commit('addMemberToProject', params);
			return true;
		}
		
		return false;
	},
	deleteMemberFromProject: function(store, params) {
		let index =  state.list_project.findIndex(p => p.code === params.project_code);
		if(index !== -1) {
			store.commit('deleteMemberFromProject', params);
			return true;
		}
		return false;
	},
	updateSchedule: function(store, params) {
		store.commit('updateSchedule', params);
	},
	updateProgressRate: function(store, params) {
		let found = _findScheduleFromListProject(params.schedule_code, params.project_code, params.member_code);
		if (found === undefined)
			return false;
		
		store.commit('updateProgressRate', params);
		return true;
	},
	updateScheduleTitle: function(store, params) {
		let found = _findScheduleFromListProject(params.schedule_code, params.project_code, params.member_code);
		if (found === undefined)
			return false;
		
		store.commit('updateScheduleTitle', params);
		return true;
	},
	updateScheduleColor: function(store, params) {
		let found = _findScheduleFromListProject(params.schedule_code, params.project_code, params.member_code);
		if (found === undefined)
			return false;
		
		store.commit('updateScheduleColor', params);
		return true;
	},
	scrollToday: function(store){
		store.commit('hscroll', store.getters.positionToday - store.getters.scrollTodayOffset);
		store.commit('setScrollingToToday', true);
	},
	scrollSpecifyDate: function(store, params){
		store.commit('hscroll', params);
		store.commit('setScrollingToToday', true);
	},
	moveToday: function(store){
		store.commit('hscroll', store.getters.positionToday - store.getters.scrollTodayOffset);
	},
	moveDefaultDay: function(store){
		let default_position = store.getters.positionAnyday(store.getters.saveDisplayLeftDay);
		store.commit('hscroll', default_position);
	},
	moveDay: function(store, params) {
		let basedate = store.getters.baseDate;
		let date;
		if (state.calendar.tick === CALENDAR_TICK.WEEK) {
			let week_target = Week.fromDate(params.date);
			let week_base = Week.fromDate(basedate);
			let diff_weeks = 0;
			let curr = week_base.begin.date;
			if (curr.getMonth() != basedate.getMonth())
				curr.setDate(curr.getDate() + 7);	// 開始が月跨ぎは表示されないのでスキップ
			let end = week_target.begin.date;
			while (curr < end) {
				diff_weeks += 1;
				curr.setDate(curr.getDate() + 7);
			}
			date = UNIT_WIDTH.TICK * diff_weeks;
		} else {
			date = store.getters.unitWidth * Math.floor((params.date.getTime() - basedate.getTime()) / 86400000);
		}
		store.commit('hscroll', date - (UNIT_WIDTH.DAY * params.shift));
	},
	setScrollingToToday: function(store, scrolling){
		store.commit('setScrollingToToday', scrolling);
	},
	setShowFreePerson: function(store, scrolling){
		store.commit('setShowFreePerson', scrolling);
	},
	deleteScheduleFromParent: function(store, params) {
		store.commit('deleteScheduleFromParent', params);
	},
	addSchedule: function(store, params) {
		store.commit('addSchedule', params);
	},
	listProjectMemberMoveTo:function(store, params){
		store.commit('listProjectMemberMoveTo', params);
	},
	listProjectMoveTo:function(store, params){
		store.commit('listProjectMoveTo', params);
	},
	memberMoveTo:function(store, params){
		store.commit('masterMemberMoveTo', params);
	},
	memberMoveToTop:function(store, params){
		store.commit('masterMemberMoveToTop', params);
	},
	removeNotification: function({ commit }, params) {
		commit('removeNotification', params);
	},
	startLoading: function(store){
		store.commit('startLoading');
	},
	endLoading: function(store){
		store.commit('endLoading');
	},
	closeSnackbar: function(store) {
		store.commit('closeSnackbar');
	},
	addNotification: function(store, notification) {
		store.commit('addNotification',notification);
	},
	startExclusive: function(store){
		store.commit('startExclusive');
	},
	endExclusive: function(store){
		store.commit('endExclusive');
	},
	startPrintSchedule: function(store){
		store.commit('startPrintSchedule');
	},
	endPrintSchedule: function(store){
		store.commit('endPrintSchedule');
	},
	setAccessToken: function(store, params) {
		store.commit('setAccessToken', params);
	},
	getAccessToken: function(store) {
		store.commit('getAccessToken');
	},
	setRefreshToken: function(store, params) {
		store.commit('setRefreshToken', params);
	},
	getRefreshToken: function(store) {
		store.commit('getRefreshToken');
	},
	setToken: function(store, params) {
		store.commit('setAccessToken', params.access_token);
		store.commit('setRefreshToken', params.refresh_token);
	},
	deleteAccessToken: function(store) {
		store.commit('deleteAccessToken');
	},
	deleteRefreshToken: function(store) {
		store.commit('deleteRefreshToken');
	},
	logout: function(store) {
		store.commit('disconnectSocketIO');
		store.commit('deleteAccessToken');
		store.commit('deleteRefreshToken');
		store.commit('initState');
	},
	setUpdate: function(store, params) {
		store.commit('setUpdate', params);
	},
	setDataSetManager: function(store, params) {
		store.commit('setDataSetManager', params);
	},
	setMasterClasses: function(store, params) {
		store.commit('setMasterClasses', params);
	},
	setMasterColors: function(store, params) {
		store.commit('setMasterColors', params);
	},
	updateListProject: function(store, params) {
		let index =  state.list_project.findIndex(p => p.code === params.code);
		if (index !== -1) {
			store.commit('updateListProject', params);
			return true;
		}
		
		return false;
	},
	addListProject: function(store, params) {
		let index =  state.list_project.findIndex(p => p.code === params.code);
		if (index === -1) {
			store.commit('addListProject', params);
			return true;
		}
		
		return false;
	},
	updateDataMember: function(store, params) {
		let index = state.master.data_member.findIndex(m => { return m.code === params.code });
		if (index !== -1) {
			store.commit('updateDataMember', params);
			return true;
		}
		return false;
	},
	addDataMember: function(store, params) {
		let index = state.master.data_member.findIndex(m => { return m.code === params.code });
		if (index === -1) {
			store.commit('addDataMembe', params);
			return true;
		}
		
		return false;
	},
	deleteDataMember: function(store, params) {
		let index = state.master.data_member.findIndex(m => { return m.code === params.member_code });
		if (index !== -1) {
			store.commit('deleteDataMember', params);
			return true;
		}
		
		return false;
	},
	updateScheduleFilter: function(store, params) {
		store.commit('updateScheduleFilter', params);
		store.commit('setScheduleListFilteringAll');
	},
	setScheduleListFilteringAll: function(store) {
		store.commit('setScheduleListFilteringAll');
	},
	setMemberFilter: function(store, params) {
		store.commit('setMemberFilter', params);
	},
	emitGanttBoardEvent: function(store, params) {
		store.commit('emitGanttBoardEvent', params);
	},
	setSaveDisplayLeftDay: function(store, params) {
		store.commit('setSaveDisplayLeftDay', params);
	},
	updateProjectPinned: function(store, params) {
		store.commit('updateProjectPinned', params);
		return true;
	},
};

export default {
	name: 'ganttboard',
	state: state,
	getters: getters,
	mutations: mutations,
	actions: actions,
};
